module.exports = __webpack_public_path__ + "assets/img/36_576.92f005ae.jpg";